<template>
  <v-container fluid class="pa-0">
    <v-data-table
      unselectable="on"
      onselectstart="return false;"
      onmousedown="return false;"
      v-bind:no-data-text="$store.state.websocket.isConnected ? 'Žádné záznamy' : 'Výpadek spojení se serverem!'"
      :sort-desc="false"
      :headers="headers"
      :items="$store.state.websocket.transactions"
      item-key="id"
      :height="$store.state.windowSize.y - 405"
      fixed-header
      :options.sync="tableOptions"
      @click:row="rowClicked"
      must-sort
      dense
      disable-pagination
      hide-default-footer
      class="tableCursor tNumbers"
    >
      <template v-slot:item="{ item }">
        <tr
          v-if="($store.state.auth.userInterfaceSettings.showAllTransactions || !item.timeexit) && item.parent === null"
          v-bind:class="{
            colorRowSelected: item.id == selectedRowID,
            colorRowWaitingForSignature: item.signStatus == 1,
            colorRowRejectedSignature: item.signStatus == 3,
            colorRowDifferentWorkplace:
              $store.state.auth.wPlaceSettings.highlightDiffIDEnter &&
              item.workplaceIDenter != $store.state.clientID &&
              item.id != selectedRowID,
          }"
        >
          <td style="width: 1%"></td>
          <td class="pa-0 ma-0" style="width: 1%" @click="showTranDetail(item)">
            <v-icon v-if="item.signStatus == 3" color="brown darken-4">{{ mdiClose }}</v-icon>
            <v-icon v-else-if="item.signStatus == 1" color="brown darken-4">{{ mdiDraw }}</v-icon>
            <v-icon v-else-if="item.timeexit != ''" color="green">{{ mdiCheck }}</v-icon>
            <v-icon v-else-if="item.car.plate != ''" color="brown darken-4">{{ mdiCar }}</v-icon>
            <v-icon v-else color="brown darken-4">{{ mdiWalk }} </v-icon>
          </td>
          <td class="px-1" v-for="header in headersData" v-bind:key="header.id" @click="rowClicked(item)">
            <span v-if="header.value.split('.').length < 2">
              <span v-if="header.value == 'timeInObject'">{{ formatTimeInObject(item[header.value]) }}</span>
              <span
                v-else-if="
                  (header.value == 'timeenter' || header.value == 'timeexit' || header.value == 'expire') && item[header.value] != ''
                "
              >
                <span v-if="header.value == 'expire'">{{ formatDate(item[header.value], $store.state.auth.df.date) }}</span>
                <span v-else>{{ formatDate(item[header.value], $store.state.auth.df.dateTime) }}</span>
              </span>
              <span v-else>{{ item[header.value] }}</span>
            </span>
            <span v-else>{{ item[header.value.split('.')[0]][header.value.split('.')[1]] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <WorkplaceTransactionDetail
      :tranUUID="tranUUID"
      :visitorID="visitorID"
      :tranSignStatus="tranSignStatus"
      :dialogTranDetail="dialogTranDetail"
      v-on:dialogTranDetail="dialogTranDetail = false"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import WorkplaceTransactionDetail from './WorkplaceTransactionDetail.vue';
import { mdiWalk, mdiCar, mdiCheck, mdiDraw, mdiClose } from '@mdi/js';

type tHeader = {
  id: number;
  value: string;
  name: string;
  text: string;
  sortable: boolean;
  width: string;
};

export default Vue.extend({
  name: 'SettingsItems',
  components: { WorkplaceTransactionDetail },
  data: () => ({
    tableOptions: {
      sortBy: ['timeexit'],
      sortDesc: [false],
    },
    selectedRowID: 0,
    headers: [] as tHeader[],
    headersData: [] as tHeader[],
    visitorID: 0,
    tranUUID: '',
    tranSignStatus: 0,
    dialogTranDetail: false,
    mdiWalk: mdiWalk,
    mdiCar: mdiCar,
    mdiCheck: mdiCheck,
    mdiDraw: mdiDraw,
    mdiClose: mdiClose,
  }),
  watch: {
    tableOptions(data: any) {
      this.$store.commit('transactionsTableOptions', data);
    },
    // Rozparsuje headre pri refresh page
    '$i18n.locale'() {
      this.parseHeaders();
    },
    '$store.state.websocket.currentDocument'() {
      switch (this.$store.state.websocket.currentDocument.tranFrom) {
        case undefined: {
          this.selectedRowID = 0;
          break;
        }
        case 'inObject': {
          this.selectedRowID = this.$store.state.websocket.currentDocument.id;
          break;
        }
        default: {
          break;
        }
      }
    },
    '$store.state.websocket.isConnected'() {
      if (!this.$store.state.websocket.isConnected) {
        this.$store.commit('transactions', []);
      }
    },
  },
  created() {
    this.$store.commit('transactionsTableOptions', this.tableOptions);
    this.parseHeaders();
    // Rozparsuje headre pri prihlaseni
  },
  methods: {
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
    parseHeaders() {
      if (this.$store.state.auth.wPlaceSettings.tranColumns !== undefined) {
        this.headers = JSON.parse(this.$store.state.auth.wPlaceSettings.tranColumns);
        // Prelozit headre podla nastaveneho jazyka
        let header = {} as any;
        for (header of this.headers) {
          header.name = this.$t(`colTran.name.${header.value}`);
          header.text = this.$t(`colTran.text.${header.value}`);
        }
        this.headersData = { ...this.headers };
        this.headers.unshift({
          name: '',
          id: 0,
          text: '',
          value: 'icon',
          sortable: false,
          width: '20px',
        });
        this.headers.unshift({
          name: '',
          id: 1,
          text: '',
          value: 'icon',
          sortable: false,
          width: '20px',
        });
      }
    },
    formatTimeInObject(timeInObject: number) {
      let fTime = '';
      if (Math.trunc(timeInObject / 60) > 23) {
        fTime = Math.trunc(timeInObject / 60 / 24) + '/';
        timeInObject = timeInObject - Math.trunc(timeInObject / 60 / 24) * 24 * 60;
      }
      fTime = fTime + ('0' + Math.trunc(timeInObject / 60)).slice(-2) + ':' + ('0' + Math.trunc(timeInObject % 60)).slice(-2);
      return fTime;
    },
    rowClicked(item: any) {
      if (this.selectedRowID === item.id) {
        this.$store.commit('currentDocument', {});
      } else {
        this.selectedRowID = item.id;
        this.$store.commit('currentDocument', { ...item });
      }
    },
    showTranDetail(tran: any) {
      this.tranUUID = tran.uuid;
      this.visitorID = tran.visitorID;
      this.tranSignStatus = tran.signStatus;
      this.dialogTranDetail = true;
    },
  },
});
</script>

<style lang="sass">
.tNumbers
  counter-reset: rowNumber-1

.tNumbers tr
  counter-increment: rowNumber

.tNumbers tr td:first-child::before
  content: counter(rowNumber) '.'

.v-data-table-header th
  white-space: nowrap !important
  text-owerflow: ellipsis !important
  padding-left: 4px !important
</style>
